import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import Modal from "src/components/Modal";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { IModalIncomeStatementLines, IOftbm002, IRefIncomeStatementModalsLines } from "./interface";
import Lines from "./components/Lines";

const ModalsIncomeStatementLines: React.ForwardRefRenderFunction<IRefIncomeStatementModalsLines, IModalIncomeStatementLines> = ({
	budgetPlanId
},ref) => {
	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();
	const {setLoading} = useLoaderBackdrop();

	// Modal Add/Change
	const modalLinesIncome = useRef<RCCRefModalProps>(null);
	const [useApportionment, setUseApportionment] = useState(true);
	const [subtitle, setSubtitle] = useState("");
	const [ofm001Id, setOfm001Id] = useState(0);
	const [linesIncome, setLinesIncome] = useState<IOftbm002[]>([]);
	const reload = async (id: number) => {
		const {data} = await RCCServicesApi.getRequest({
			method: "IncomeStatement/GetIncomeLines",
			urlParameters: {
				id,
				budgetPlanId
			}
		});
		setUseApportionment(data.useApportionment);
		return data.oftbm002 as IOftbm002[];
	};
	const actionButtonChange = async (id: number, name: string) => {
		try{
			setLoading(true);
			const data = await reload(id);
			setLinesIncome(data);
			setSubtitle(name);
			setOfm001Id(id);
			setLoading(false);
			modalLinesIncome.current?.openModal();
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao buscar linhas do demonstrativo"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		actionButtonChange
	}));

	return (
		<Modal
			ref={modalLinesIncome}
			header={{
				title: translate("Configurar"),
				subtitle,
				icon: {
					name: "settings"
				}
			}}
			footer={{
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Salvar"),
				cancelButtonText: translate("Cancelar"),
				showSaveButton: false
			}}
			withoutForm
		>
			<Lines 
				lines={linesIncome}
				ofm001Id={ofm001Id}
				budgetPlanId={budgetPlanId}
				useApportionment={useApportionment}
				reloadLines={async () => {
					const data = await reload(ofm001Id);
					return data;
				}}
			/>
		</Modal>
	);
};

export default forwardRef(ModalsIncomeStatementLines);
